import { FormControl, FormLabel, Input } from '@mui/joy';
import { useState } from 'react';

const EnhancedInput = ({ 
  label, 
  placeholder, 
  required = false,
  error = false,
  helperText,
  startDecorator,
  endDecorator,
  ...props 
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e) => {
    setIsFocused(false);
    setHasValue(e.target.value !== '');
  };

  return (
    <FormControl 
      sx={{ 
        position: 'relative',
        '&:hover .MuiFormLabel-root': {
          color: 'success.600',
        }
      }}
    >
      {label && (
        <FormLabel
          sx={{
            position: isFocused || hasValue || props.value ? 'absolute' : 'static',
            top: isFocused || hasValue || props.value ? -8 : 'auto',
            left: isFocused || hasValue || props.value ? 12 : 'auto',
            bgcolor: 'background.body',
            px: isFocused || hasValue || props.value ? 1 : 0,
            fontSize: isFocused || hasValue || props.value ? 'xs' : 'sm',
            color: error ? 'danger.500' : isFocused ? 'success.600' : 'neutral.700',
            transition: 'all 0.2s ease',
            transform: isFocused ? 'translateY(0)' : 'translateY(0)',
            zIndex: 1,
            pointerEvents: 'none',
          }}
        >
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </FormLabel>
      )}
      
      <Input
        placeholder={placeholder}
        startDecorator={startDecorator}
        endDecorator={endDecorator}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e) => {
          setHasValue(e.target.value !== '');
          if (props.onChange) props.onChange(e);
        }}
        sx={{
          '&:focus-within': {
            borderColor: error ? 'danger.500' : 'success.500',
            boxShadow: error 
              ? '0 0 0 2px rgba(220, 53, 69, 0.25)'
              : '0 0 0 2px rgba(0, 168, 132, 0.25)',
          },
          '&:hover': {
            borderColor: error ? 'danger.400' : 'success.400',
          },
          borderColor: error ? 'danger.300' : 'neutral.300',
          transition: 'all 0.2s ease',
          '& .MuiInput-startDecorator': {
            color: isFocused ? 'success.600' : 'neutral.500',
          },
          '& .MuiInput-endDecorator': {
            color: isFocused ? 'success.600' : 'neutral.500',
          },
        }}
        {...props}
      />
      
      {helperText && (
        <FormLabel
          sx={{
            fontSize: 'xs',
            color: error ? 'danger.500' : 'neutral.600',
            mt: 0.5,
            ml: 1,
          }}
        >
          {helperText}
        </FormLabel>
      )}
    </FormControl>
  );
};

export default EnhancedInput;